import { BASE_URL } from "../api";

let loadPromise = null;

function waitForPlaces(maxMs = 15000) {
  const start = Date.now();
  return new Promise((resolve, reject) => {
    const id = setInterval(() => {
      if (window.google?.maps?.places) {
        clearInterval(id);
        resolve();
      } else if (Date.now() - start > maxMs) {
        clearInterval(id);
        reject(new Error("Places library not available"));
      }
    }, 50);
  });
}

function scriptAlreadyOnPage() {
  return document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
}

/**
 * Une seule injection du JS Maps + Places pour toute l’app (évite doublons / erreurs Google).
 * URL avec loading=async + v=weekly (recommandations Google).
 */
export function loadGoogleMapsPlaces() {
  if (typeof window === "undefined") return Promise.resolve();

  if (window.google?.maps?.places) return Promise.resolve();

  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    if (scriptAlreadyOnPage()) {
      await waitForPlaces();
      return;
    }

    const base =
      BASE_URL && String(BASE_URL).trim()
        ? BASE_URL.trim()
        : window.location.origin;

    const res = await fetch(`${base}/api/config/google-maps-key`, {
      credentials: "include",
    });
    const data = await res.json().catch(() => ({}));
    const key = data?.key;
    if (!key) throw new Error("Google Maps key unavailable");

    await new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        key
      )}&libraries=places&loading=async&v=weekly`;
      s.async = true;
      s.defer = true;
      s.dataset.pmsGoogleMaps = "1";
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Failed to load Google Maps"));
      document.head.appendChild(s);
    });

    await waitForPlaces();
  })();

  loadPromise.catch(() => {
    loadPromise = null;
  });

  return loadPromise;
}
